import { ref } from 'vue';
import { $api } from '@/services';

const error = ref(null);
const loading = ref(false);

export async function updateOrg(data: any) {
	error.value = null;
	try {
		const res = await $api.org.updateOrg(data);
		return res?.data;
	} catch (err) {
		error.value = err?.response?.data?.errors || err.message;
	} finally {
		loading.value = false;
	}
}

export function useUpdateOrg() {
	return { update_org_error: error, loading, updateOrg };
}
